import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BuildingTypeService } from 'src/app/core/services/buildingType/building-type.service';
import { PropertyUnit } from 'src/app/models/interfaces/property-unit';
import { PropertyUnitsService } from '../../services/property-units.service';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'unit-details',
  templateUrl: './unit-details.component.html',
  styleUrls: ['./unit-details.component.scss']
})
export class UnitDetailsComponent {

  @Input() unitDetails: PropertyUnit | null = null;
  buildingTypes: any[] = [];
  unitImage = {
    name: 'صورة العقار',
    fileLabel: <string | null>null,
    progress: false,
    progressVal: 0,
    file: <string | File | null>null,
  };

  @Input({ required: true }) propertyDetailsFormGroup!: FormGroup;

  constructor(private buildingTypeService: BuildingTypeService,
    private propertyUnitsService: PropertyUnitsService
  ) { }

  ngOnInit() {
    this.getBuildingType();
    this.patchPropertyDetails();
    this.unitImage['fileLabel'] = this.unitDetails?.thumbnail || null;
  }

  getBuildingType() {
    this.buildingTypeService.getBuildingTypes().subscribe(
      (data) => { this.buildingTypes = data; }
    );
  }

  patchPropertyDetails() {
    if (this.unitDetails) {
      this.propertyDetailsFormGroup.patchValue({
        custom_name: this.unitDetails.custom_name,
        building_type: this.unitDetails.building_type?.id,
        surfaces_space: this.unitDetails.surfaces_space,
        age: this.unitDetails.age,
      });
    }
  }

  deleteImage(event: any) {
    let formData = new FormData();
    formData.append('thumbnail', '');
    if (this.unitDetails?.stakeholder?.id && this.unitDetails?.id) {
      this.propertyUnitsService.deletePropertyThumbnail(this.unitDetails?.stakeholder?.id, this.unitDetails?.id)
      .subscribe({
        next: () => {
          this.unitImage.fileLabel = null;
          this.unitImage.file = null;
        }
      });
    }
  }

  handleImage(event: any) {
    if (event.files && event.files.length > 0) {
      const file = event.files[0];
      let formData = new FormData();
      formData.append('thumbnail', event.files[0]);
      if (this.unitDetails?.stakeholder?.id && this.unitDetails?.id) {
        this.updatePropertyUnitThumbnail(this.unitDetails.stakeholder.id, this.unitDetails.id, formData);
      }
    }
  }

  updatePropertyUnitThumbnail(clientId: number, unitId: number, thumbnail: FormData) {
    this.propertyUnitsService.uploadPropertyThumbnail(clientId, unitId, thumbnail).subscribe({
      next: (event) => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.unitImage.progress = false;
            break;
          case HttpEventType.UploadProgress:
            this.unitImage.progressVal = Math.round(
              (event.loaded / event.total) * 100,
            );
            this.unitImage.progress = true;
            break;
          case HttpEventType.Response:
            this.unitImage.progress = false;
            this.unitImage.file = thumbnail.get('thumbnail') as File;
            this.unitImage['fileLabel'] = event.body.data.thumbnail || 'thumbnail.jpg';
            setTimeout(() => {
              this.unitImage.progressVal = 0;
            }, 0);
        }
      },
      error: () => {
        this.unitImage.progress = false;
      }
    });
  }
}
